<script>
	import {push, replace} from "svelte-spa-router";
	import Controlador from "../controlador.svelte";
	import {onMount,beforeUpdate} from "svelte";
	import {docs,logueo} from "../store.js";
	import ItemDeposito from "../componentes/itemDeposito.svelte";
	let c;
	export let params;
	let botones = [
		{nombre:"Volver",icon:"ri-arrow-left-line",href:"#/home"},
		{nombre:"Agregar Producto/Servicio",icon:"ri-add-line",href:"#/deposito/agregar"},
		{nombre:"Cargar Stock",icon:"ri-add-line",href:"#/deposito/stock"},
		{nombre:"Categorias",icon:"ri-add-line",href:"#/deposito/categorias"},
	]
	let categorias = [];
	let filtro = "";
	let filtroCategoria = "";
	let deposito = [];
	let modo = 0;
	let editar = 0;
	onMount(()=>{
		editar = params.categoria;
		categorias = $docs.find((el)=>el._id == "config:categorias").categorias;
		//deposito = $docs.filter((el)=>el._id.includes("deposito:"));
		if (params.categoria == -1){
			modo = 0;
		} else {
			modo = 1;
			filtroCategoria = categorias[params.categoria];
		}
		if (!$logueo){
			replace('/');
		}
	})
	beforeUpdate(()=>{
		if (modo != 0){
			deposito = $docs.filter((el)=>el._id.includes("deposito:")).filter((el)=>el.nombre.toLowerCase().includes(filtro.toLowerCase()));
			if (filtroCategoria != ""){
				deposito = deposito.filter((el)=>el.categoria == filtroCategoria);
			}
		}
	})
	function seleccionar(cat,i){
		filtroCategoria = cat;
		editar = i;
		modo = 1;
	}
	function volver(){
		filtroCategoria = "";
		modo = 0;
	}
	function agregarProductoCat(){
		push(`/deposito/${editar}/agregar`);
	}
</script>
<Controlador bind:this={c}></Controlador>
<div class="p-4 w-screen max-w-full h-full min-h-screen  flex flex-col items-center">
	{#if modo == 0}
	<div class="w-full sm:w-3/4 grid grid-cols-2 grid-rows-2 gap-2 mb-2">
		{#each botones as b}
			<a href={b.href} class="w-full text-xs md:text-md text-white p-2 bg-red-500 cursor-pointer flex items-center justify-center rounded shadow ">
				<i class={b.icon} />
				{b.nombre}
		</a>
		{/each}
	</div>
	{/if}
	{#if modo == 0}
		{#each categorias as cat,i}
			<button on:click={()=>{seleccionar(cat,i)}} class="w-full m-2 p-2 fondo text-white rounded shadow sm:w-3/4">{cat}</button>
		{/each}
	{:else}
	<div class="w-full sm:w-3/4 flex items-center justify-center">
		<button on:click={volver} class="w-full m-2 p-2 flex items-center justify-center bg-red-500 text-white rounded shadow">
			<i class="ri-arrow-left-line" /> Volver
		</button>
		<button on:click={agregarProductoCat(filtroCategoria)} class="w-full m-2 p-2 flex items-center justify-center bg-red-500 text-white rounded shadow">
			<i class="ri-add-line" /> Agregar Producto
		</button>
	</div>	
	<input bind:value={filtro} class="w-full sm:w-3/4 p-2 rounded shadow" type="text" placeholder="Filtro" />
	{#each deposito as i}
		<ItemDeposito item={i} />
	{/each}
	{/if}
</div>
<style>
	.fondo{
		background-color: #FA8072;
	}
</style>
